import {observer} from 'mobx-react-lite'
import {GetStaticProps} from 'next'
import {SanityKeyed} from 'sanity-codegen'

import SEO from 'components/elements/SEO'
import LayoutHome from 'components/layouts/LayoutHome'
import TemplateCreateDocumentInvoice from 'components/templates/TemplateCreateDocumentInvoice'
import sanityClient from 'src/backend/lib/sanityClient'
import {TPageComponent} from 'src/types'
import {Invoice as IBaseInvoice} from 'src/types/__sanitySchema__'
import {getKeywords} from 'src/utils'

export interface IInvoiceContent
	extends TModify<
		IBaseInvoice,
		{
			reasons: {
				_type: 'reasons'
				title?: string
				items?: Array<
					SanityKeyed<{
						_type: 'item'
						title?: string
						description?: string
						icon?: string
					}>
				>
			}
		}
	> {}

interface IInvoiceProps {
	invoiceContent: IInvoiceContent
}

const Invoice: TPageComponent<IInvoiceProps> = ({invoiceContent}) => {
	return (
		<>
			<SEO
				title={invoiceContent?.seo?.seo_title || invoiceContent?.title || 'Make your Invoice'}
				description={invoiceContent?.seo?.meta_description}
				keywords={getKeywords(
					invoiceContent?.seo?.focus_keyword,
					invoiceContent?.seo?.focus_synonyms,
				)}
			/>
			<TemplateCreateDocumentInvoice {...{invoiceContent}} />
		</>
	)
}

export const getStaticProps: GetStaticProps<IInvoiceProps> = async () => {
	try {
		const invoiceContent = (
			await sanityClient.fetch<IInvoiceContent[]>(`*[_type == "invoice"]{
			...,
			
			testimonials{
				...,
				items[]{
					...,
					"photo": photo.asset->url
				}
			},
			reasons{
				...,
				items[]{
					...,
					"icon": icon.asset->url
				}
			}
		}`)
		)[0]
		return {
			props: {invoiceContent},
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

Invoice.displayName = 'Invoice'
Invoice.Layout = LayoutHome

export default observer(Invoice)
